const config = {
  i18n: {
    defaultLocale: 'en',
    locales: ['en'],
    localeDetection: false,
  },
  reloadOnPrerender: process.env.NODE_ENV === 'development',
  serializeConfig: false,
  // Ensure translations are loaded properly in serverless environments
  fallbackLng: 'en',
  debug: process.env.NODE_ENV === 'development',
  interpolation: {
    escapeValue: false,
  },
};

module.exports = config;
